import { Store } from '@ngrx/store';
import { Component, signal, model, computed, input, OnInit, effect } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KENDO_COMBOBOX } from "@progress/kendo-angular-dropdowns";
import { IVessel, IVesselOrganization } from '@pmis3/master-data-core';
import { ControlsModule } from '@pmis3/ui-controls';
import { VesselVisitDetailLabelledInformationComponent } from "../vessel-visit-detail-labelled-information/vessel-visit-detail-labelled-information.component"
import { KENDO_LABELS } from "@progress/kendo-angular-label";
import { VesselVisitDetailOrganizationComponent } from "../vessel-visit-detail-organization/vessel-visit-detail-organization.component"
import { KENDO_TEXTBOX, KENDO_RADIOBUTTON, InputsModule } from "@progress/kendo-angular-inputs";
import { FormsModule } from "@angular/forms";
import { IconsModule } from '@progress/kendo-angular-icons';
import { IVesselVisit, selectSelectedVesselVisit, selectVessels, UpdateSelectedVesselVisit } from '@pmis3/vessel-activity-core';

@Component({
    selector: 'pmis3-vessel-visit-detail-vessel',
    standalone: true,
    imports: [CommonModule,
        ControlsModule,
        KENDO_COMBOBOX,
        VesselVisitDetailLabelledInformationComponent,
        KENDO_LABELS,
        VesselVisitDetailOrganizationComponent,
        KENDO_TEXTBOX,
        KENDO_RADIOBUTTON,
        FormsModule,
        IconsModule,
        InputsModule],
    templateUrl: 'vessel-visit-detail-vessel.component.html',
    styleUrl: './vessel-visit-detail-vessel.component.css',
})
export class VesselVisitDetailVesselComponent {
    vesselVisit = this.store.selectSignal(selectSelectedVesselVisit);
    vessels = this.store.selectSignal(selectVessels);

    state = computed(() => {
        const matchingVessel = this.vessels().find(v => v.id == this.vesselVisit()?.vesselId);
        return {
            vessel: signal(matchingVessel)
        }
    })

    informationConfirmation = model<boolean | null>(null)
    disabledLabel = computed(() => !this.state().vessel())
    collapsed = input(false);
    disableRadioButton = computed(() => !this.state().vessel() || this.collapsed())

    constructor(private store: Store<any>) {}

    onVesselSelected() {
        // console.log(selected)
        // this.removeSelectedVessel();
        // this.vessel.set(selected);
        // this.informationConfirmation.set(null);

        const updatedVV = {
            ...this.vesselVisit(),
            vessel: this.state().vessel(),
            vesselId: this.state().vessel()?.id
        } as IVesselVisit;
        this.store.dispatch(UpdateSelectedVesselVisit({ selectedVesselVisit: updatedVV }))
    }

    // onConfirmationChange(event: any): void {
    //     if (this.informationConfirmation() && this.vessel()) {
    //         const updatedVV = {
    //             ...this.vesselVisit(),
    //             vessel: this.vessel()
    //         } as IVesselVisit;
    //         this.store.dispatch(UpdateSelectedVesselVisit({ selectedVesselVisit: updatedVV }))
    //     } else if (this.informationConfirmation() === false) {
    //         this.removeSelectedVessel();
    //     }
    // }

    // removeSelectedVessel() {
    //     const updatedVV = {
    //         ...this.vesselVisit(),
    //         vessel: undefined
    //     } as IVesselVisit;
    //     this.store.dispatch(UpdateSelectedVesselVisit({ selectedVesselVisit: updatedVV }))
    // }
}